/**
 * Consent-gated tracking loader.
 * Fires only after the user grants analytics/marketing consent (Cookie banner / preferences).
 * IDs are placeholders for the public site (per spec) — replace via window.__EUREKA_TRACKING__ later if needed.
 */
const IDS = {
  ga4: 'G-9ZSPBNGG2C',
  gtm: 'GTM-NLK9LMR9',
  meta_pixel: '697190129010362',
  linkedin: '1499937',
};

const flags = { gtm: false, ga4: false, meta: false, linkedin: false };

const inject = (src, async = true, id) => {
  if (id && document.getElementById(id)) return;
  const s = document.createElement('script');
  if (async) s.async = true;
  s.src = src;
  if (id) s.id = id;
  document.head.appendChild(s);
};

const loadGTM = () => {
  if (flags.gtm) return; flags.gtm = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  inject(`https://www.googletagmanager.com/gtm.js?id=${IDS.gtm}`, true, 'gtm-script');
};

const loadGA4 = () => {
  if (flags.ga4) return; flags.ga4 = true;
  inject(`https://www.googletagmanager.com/gtag/js?id=${IDS.ga4}`, true, 'ga4-script');
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', IDS.ga4, { anonymize_ip: true });
};

const loadMetaPixel = () => {
  if (flags.meta) return; flags.meta = true;
  // eslint-disable-next-line
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', IDS.meta_pixel);
  window.fbq('track', 'PageView');
};

const loadLinkedIn = () => {
  if (flags.linkedin) return; flags.linkedin = true;
  window._linkedin_partner_id = IDS.linkedin;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(IDS.linkedin);
  // eslint-disable-next-line
  (function(l){if(!l){window.lintrk=function(a,b){window.lintrk.q.push([a,b])};window.lintrk.q=[]}var s=document.getElementsByTagName("script")[0];var b=document.createElement("script");b.type="text/javascript";b.async=true;b.src="https://snap.licdn.com/li.lms-analytics/insight.min.js";s.parentNode.insertBefore(b,s);})(window.lintrk);
};

export const applyConsent = (consent) => {
  if (!consent) return;
  // Analytics: GA4 + GTM
  if (consent.analytics) { loadGTM(); loadGA4(); }
  // Marketing: Meta + LinkedIn
  if (consent.marketing) { loadMetaPixel(); loadLinkedIn(); }
};

export const initTrackingListener = () => {
  // Apply existing consent immediately
  try { applyConsent(JSON.parse(localStorage.getItem('eureka_consent') || 'null')); } catch (_e) { /* no consent yet */ }
  // Listen for changes
  window.addEventListener('eureka:consent', (e) => applyConsent(e.detail));
};
